import { refs, domReady, dispatchEvent, booleanDataset } from '../modules/utils.js';

class NavBar extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#listeners();
  }

  #listeners() {
    this.refs.mobileMenu?.addEventListener('click', () => {
      dispatchEvent('navbar:mobilemenu');
    });

    document.addEventListener('mobilemenu:display', ({ detail }) => {
      booleanDataset(this.refs.mobileMenu, 'active', detail.value);
    });
  }
}

customElements.define('nav-bar', NavBar);
